import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { logoutUser } from "../../slices/thunks";

//redux
import { useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";

const Logout = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Clear all cache and logout - this will redirect to /login
    dispatch(logoutUser(props.router?.navigate || null));
  }, [dispatch, props.router]);

  // Show loading state while logout is processing
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Logging out...</span>
        </div>
        <p className="mt-2">Logging out...</p>
      </div>
    </div>
  );
};

Logout.propTypes = {
  history: PropTypes.object,
};


export default withRouter(Logout);